<template>
  <div class="c-add-agent-form">
    <div v-if="loading">
      <b-skeleton class="mb-3" type="input"></b-skeleton>
      <b-skeleton class="mb-3" type="input"></b-skeleton>
      <b-skeleton class="mb-3" type="input"></b-skeleton>
    </div>
    <div v-else>
      <b-form>
        <b-form-group id="input-group-1" label="آیدی" label-for="input-1">
          <b-form-input
            :disabled="agentId !== ''"
            id="input-1"
            v-model="id"
            type="text"
            placeholder="آیدی..."
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-2"
          label="نام پشتیبان"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            v-model="name"
            placeholder="نام پشتیبان"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-2"
          label="شماره موبایل"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            v-model="mobile"
            placeholder="شماره موبایل"
            required
          ></b-form-input>
        </b-form-group>

        <b-button
          v-if="agentId === ''"
          :disabled="!id || !name || !mobile"
          type="button"
          variant="primary"
          @click="onSubmit"
        >
          ثبت
        </b-button>

        <b-button
          v-else
          :disabled="!id || !name || !mobile"
          type="button"
          variant="primary"
          @click="edit"
        >
          ویرایش
        </b-button>

        <b-button class="mr-2" type="reset" variant="link" @click="closeModal()"
          >انصراف</b-button
        >
      </b-form>
    </div>
  </div>
</template>

<script>
import Agents from "@/httpservices/Agents";

export default {
  name: "AddAgentsForm",

  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },

    agentId: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      id: "",
      name: "",
      mobile: "",
      status: "",
      loading: true,
    };
  },

  mounted() {
    if (this.agentId !== "") {
      Agents.getAgent(this.agentId)
        .then((response) => {
          this.id = response.data.data.id;
          this.name = response.data.data.name;
          this.status = response.data.data.status;
          this.mobile = response.data.data.mobile;
        })
        .catch((err) => {
          console.log(err);
        });
    }

    this.loading = false;
  },

  methods: {
    edit() {
      Agents.editAgent(this.id, this.name, this.mobile, this.status)
        .then(() => {
          this.$emit("agentEdited");
        })
        .catch((err) => {
          let message = err.response.data.error;
          if (message === "id is not valid") {
            message = "آیدی نا معتبر است";
          } else if (message === "name is not valid") {
            message = "نام نا معتبر است";
          } else if (message === "mobile is not valid") {
            message = "فرمت شماره موبایل نا معتبر است.";
          } else if (message === "id is exist") {
            message = "آیدی وارد شده قبلا در سیستم ثبت شده است";
          } else if (message === "mobile is exist") {
            message = "شماره موبایل وارد شده قبلا در سیستم ثبت شده است";
          }

          this.$swal({
            position: "center",
            icon: "error",
            title: message,
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },

    onSubmit(event) {
      event.preventDefault();

      Agents.addAgent(this.id, this.name, this.mobile)
        .then((response) => {
          this.$emit("agentAdded");
        })
        .catch((err) => {
          let message = err.response.data.error;
          if (message === "id is not valid") {
            message = "آیدی نا معتبر است";
          } else if (message === "name is not valid") {
            message = "نام نا معتبر است";
          } else if (message === "mobile is not valid") {
            message = "فرمت شماره موبایل نا معتبر است.";
          } else if (message === "id is exist") {
            message = "آیدی وارد شده قبلا در سیستم ثبت شده است";
          } else if (message === "mobile is exist") {
            message = "شماره موبایل وارد شده قبلا در سیستم ثبت شده است";
          }

          this.$swal({
            position: "center",
            icon: "error",
            title: message,
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },

    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
.c-add-agent-form {
}
</style>
